import React, { Component } from 'react';
import { getFooterBannerList, removeFooterBanner } from '../../modules/Api';
import ReactTable from 'react-table';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import { END_POINT } from '../../constants/config';
import ACL from '../../components/ACL';
class FooterBanner extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getFooterBannerList(query, (res) => {
            this.setState({
                items: res.data.data.data,
                last_page: res.data.data.last_page,
                count: res.data.data.total,
                pageSize: res.data.data.per_page
            })
        });
    }

    onChange(state) {
        this.setState({ pageSize: state.pageSize });
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if (state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc' : 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;
        this.fetchData(query);
    }

    removeBanner(id) {
        const warningMessage = `آیا از حذف بنر اطمینان کامل دارید ؟ `;
        if (window.confirm(warningMessage)) {
            removeFooterBanner(id, () => {
                notification.open({
                    message: `بنر با موفقیت حذف شد!`,
                    description: ``
                })
            });
            this.fetchData();
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                // filterable: true,
            },
            {
                Header: 'وضعیت',
                accessor: 'Status',
                // filterable: true,
                Cell: (row) => row.original.is_active ? 'فعال' : 'غیر فعال'
            },
            {
                Header: 'تگ آلت',
                accessor: 'title',
                // filterable: true,
                Cell: (row) => <span>{row.original.alt} </span>
            },
            {
                Header: 'عکس',
                accessor: 'title',
                // filterable: true,
                Cell: (row) => (<img src={`${row.original.image.includes('http') ? row.original.image : END_POINT + row.original.image}`} style={{ width: '300px', height: '50px' }} alt={row.original.link} />)
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                // sortable: false,
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="coupons_management|coupons_delete">
                            <span onClick={() => { this.removeBanner(row.original.id) }} style={{ color: 'tomato', cursor: 'pointer', marginTop: '20%' }} >X </span>

                            <span style={{ color: 'rgb(39, 105, 125)', cursor: 'pointer' }} onClick={() => { window.open(`/footer-banner/edit/${row.original.id}`, "_blank") }}>
                                Edit
                            </span>
                        </ACL>
                    </React.Fragment>
                )
            },

        ]
        return (
            <div style={{ textAlign: 'center' }}>
                <div className="btn-container">
                    <ACL component="div" has_permission="coupons_management|coupons_add"><Button type="primary" onClick={() => history.item.push(`/footer-banner/add`)}>افزودن بنر جدید</Button></ACL>
                </div>

                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => { this.onChange(state) }}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page} />
            </div>
        );
    }
}

export default FooterBanner;



// WEBPACK FOOTER //
// ./src/containers/FooterBanner/index.js